import { FlyUIProvider, FullScreenLoader } from "@wayflyer/flyui";

export const Fallback = () => (
  <FlyUIProvider theme="wayflyer">
    <FullScreenLoader />
  </FlyUIProvider>
);
